import { ReactElement, useMemo } from 'react'

import { useMatches } from 'react-router-dom'

import { cn } from '@tribeplatform/react-components/utils/cn'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export function Breadcrumbs() {
  const matches = useMatches()
  const crumbs = useMemo(
    () =>
      matches.reduce(
        (acc, match) => {
          const { handle } = match
          if (!handle || typeof handle !== 'object' || !('crumb' in handle)) {
            return acc
          }
          const { crumb } = handle

          if (typeof crumb !== 'function') {
            return acc
          }

          acc.push(crumb as () => ReactElement) // TODO: there is no way that we can type this correctly

          return acc
        },
        [] as (() => ReactElement)[],
      ),
    [matches],
  )

  const numberOfItems = crumbs.length * 2 - 1 // we need a divider for each path

  return (
    <ul className="flex items-center h-full gap-1">
      {Array.from({ length: numberOfItems }).map((_, index) => {
        const key = `crumb-${index}`
        if (index % 2 === 0) {
          const Comp = crumbs[index / 2]

          return (
            <li
              key={key}
              className={cn(
                'text-content-muted text-sm hover:text-content transition-colors',
                {
                  'text-content font-semibold': index === numberOfItems - 1,
                },
              )}
            >
              <Comp />
            </li>
          )
        }

        return (
          <li className="text-content-muted" key={key}>
            <SvgIcon name="chevron-right" />
          </li>
        )
      })}
    </ul>
  )
}
